import { selector } from 'recoil';
import { allCoverablesOnsaAtom } from '../atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { getOnsaCoverable } from '../../utils/coverablesUtil';

export const currentOnsaCoverableSelector = selector({
    key: 'currentOnsaCoverableSelector',
    get: ({ get }) => {
        const onsaCoverables = get(allCoverablesOnsaAtom);
        const { flavourName, fixedId } = get(getOnsaCurrentProductSelector);
        return getOnsaCoverable(onsaCoverables, flavourName, fixedId);
    }
});
